<div class="loader-box block" id="custom-loader">
    <div class="loader"></div>
</div>   